// extracted by mini-css-extract-plugin
module.exports =  {"browser-banner":"browser-banner-wblrf","label":"label-m7EYw","close":"close-MRC_s"};